module.exports = __webpack_public_path__ + "static/img/product2.424d6cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product2.png
// module id = KjZN
// module chunks = 1